import React, { FC, ReactElement, ReactNode } from "react";

import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Container, { ContainerProps } from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import HelpInfo from "./HelpInfo";

type SettingComponentProps = ContainerProps & {
  label: string;
  docsKey?: string;
  extraElement?: ReactElement;
  fullWidthChildren?: ReactNode;
};

export const SettingSection: FC<
  React.PropsWithChildren<SettingComponentProps>
> = ({
  label,
  docsKey,
  extraElement,
  fullWidthChildren,
  children,
  sx,
  ...props
}): ReactElement => {
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ pb: 3, pt: 3, ...sx }}
      {...props}
    >
      <Stack>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 items-center">
          <Stack gap={1}>
            <Typography
              variant="h6"
              sx={{
                minWidth: "20vw",
              }}
              className="flex items-center gap-1"
            >
              <span>{label}</span>
              {docsKey && <HelpInfo docsKey={docsKey} />}
            </Typography>
            {extraElement && <Box m={1}>{extraElement}</Box>}
          </Stack>
          <div className="w-full">{children}</div>
        </div>
        {fullWidthChildren && (
          <Box sx={{ px: 4, py: 2 }}>{fullWidthChildren}</Box>
        )}
      </Stack>
    </Container>
  );
};
export default SettingSection;
